import React from "react";
import { LOGGED_IN_USER_KEY } from "../../../constants";

class HiddenInput extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      value: sessionStorage.getItem(LOGGED_IN_USER_KEY),
    };
  }

  handleChange(e) {
    this.setState(
      {
        value: e.target.value,
      },
      this.props.onChange.bind(null, e.target.value)
    );
  }

  componentDidMount() {
    this.nameInput.focus();
    this.setState({
      value: sessionStorage.getItem(LOGGED_IN_USER_KEY),
    });
  }

  render() {
    return (
      <input
        type="text"
        name={this.props.name}
        ref={(input) => {
          this.nameInput = input;
        }}
        id={this.props.id}
        aria-labelledby={this.props.labelId}
        className={this.props.classes.input}
        placeholder={this.props.placeholder}
        style={{ display: "block" }}
        value={sessionStorage.getItem(LOGGED_IN_USER_KEY) || ""}
        required={this.props.required ? "required" : undefined}
        onChange={this.handleChange.bind(this)}
        onBlur={this.handleChange.bind(this)}
        onSubmit={this.handleChange.bind(this)}
        onKeyDown={this.props.onKeyDown}
      />
    );
  }
}

HiddenInput.defaultProps = {
  classes: {},
  name: "",
  id: "",
  value: sessionStorage.getItem(LOGGED_IN_USER_KEY),
  placeholder: "",
  onChange: () => {
    sessionStorage.getItem(LOGGED_IN_USER_KEY);
  },
  onBlur: () => {
    sessionStorage.getItem(LOGGED_IN_USER_KEY);
  },
  onSubmit: () => {
    sessionStorage.getItem(LOGGED_IN_USER_KEY);
  },
  onKeyDown: () => {
    sessionStorage.getItem(LOGGED_IN_USER_KEY);
  },
};

export default HiddenInput;
